<template>
  <WizardContainer
    v-if="$route.name !== 'verify-email'"
    width="800px"
    height="500px"
  >
    <router-view
      v-if="thisRouteMatchesErrorPageRoute"
      v-slot="{ Component }"
    >
      <component :is="Component" />
    </router-view>
  </WizardContainer>
  <router-view
    v-else-if="$route.name === 'verify-email' && thisRouteMatchesErrorPageRoute"
    v-slot="{ Component }"
  >
    <component :is="Component" />
  </router-view>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import { useWizard } from '@/stores/wizard/wizard';
import { mapActions } from 'pinia';
import { useAppGate } from '@/stores/app/gate';

export default {
  name: 'SignupGate',

  components: {
    WizardContainer,
  },

  computed: {
    thisRouteMatchesErrorPageRoute() {
      return this.$route.name === useAppGate().errorPageRoute;
    },
  },
  // eslint-disable-next-line consistent-return
  async mounted() {
    if (!this.thisRouteMatchesErrorPageRoute) {
      return this.$router.replace({ name: 'root' });
    }

    if (this.$route.name !== 'maintenance') {
      await this.getFirstNameEmailAndCompany();
    }
  },
  methods: {
    ...mapActions(useWizard, ['getFirstNameEmailAndCompany']),
  },
};
</script>
